function ngRequired() {
  return {
    restrict: 'A',
    require: '?^^ogFormfield',
    link: function($scope, $element, $attrs, ogFormfield) {
      $scope.$watch(() => $scope.$eval($attrs.ngRequired), (val) => {
        if (ogFormfield) {
          ogFormfield.isRequired = val;
        }
      });
    }
  };
}

ngRequired.$inject = [];

module.exports = ngRequired;
